import React from 'react';
import { Box, Container } from '@qga/roo-ui/components';

import RouteErrorMessage from '@/components/RouteErrorMessage';
import SearchPanel from '@/components/SearchPanel';
import isDataNoResults from '@/utils/isDataNoResults';
import { useDestination as v2UseDestination } from '@/v2/contexts/destination';
import useDestination from '../../../../hooks/useDestination';
import useGetPackagesCheapestOffer from '../../hooks/useGetPackagesCheapestOffer';

const CheckAvailability = React.memo(() => {
  const { packagesWithCheapestOffer, error } = useGetPackagesCheapestOffer();
  const d = useDestination();
  const dV2 = v2UseDestination();

  const destination = d || dV2;

  return (
    <Container px={['0', null, null]} mx={['0', null, 'auto']}>
      <Box
        bg="background.card"
        borderRadius="sm"
        mt={['4', null, '0']}
        boxShadow="light"
      >
        <Box pt={['4', null, '5']} pb={['4', null, '5']} px={['3', null, '5']}>
          <SearchPanel />
          {(isDataNoResults(packagesWithCheapestOffer) || error) && (
            <Box>
              <RouteErrorMessage destination={destination} />
            </Box>
          )}
        </Box>
      </Box>
    </Container>
  );
});

export default CheckAvailability;
